export default {
  common: {
    clearAll: 'Clear ALL',
    restart: '再起動'
  },
  download: {
    bodyText: '以下のリンクをクリックして、%{products} をダウンロードしてください',
    bothProducts: 'PlayBase および/または Nexus',
    bodyTextFromAcceptInvitation:
      'このプロセスには時間がかかります。その間、Metrica Sportsを通常通りに引き続き使用できます。',
    bodyTextFromDeclineInvitation:
      '招待を辞退しました！以下のリンクをクリックして、%{products} をダウンロードしてください',
    bodyTextFromTrial:
      'トライアルセットアップへようこそ！登録したメールアドレスを確認して、確認リンクをチェックしてください（迷惑メールフォルダも確認してください）。',
    bodyTitle: 'ダウンロード',
    bodyTitleFromAcceptInvitation: 'アカウントを切り替えています',
    bodyTitleFromDeclineInvitation: '招待状が拒否されました',
    bodyTitleFromTrial: '登録完了',
    play2: {
      description:
        'Metrica PlayBase は、アマチュアおよびプロシューマーのコーチ、小規模クラブ、独立したアナリスト向けに設計された直感的な分析ツールです。パフォーマンス評価のプロセスを簡素化し、誰にでもアクセスしやすくします。',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    play3: {
      description:
        'Metrica Nexus は、包括的なパフォーマンスの洞察を求めるエリートのアナリストやコーチ向けにカスタマイズされています。先進的なツールを使えば、チーム戦略を強化し、成功を収めることができます。',
      keyFeature1: {},
      keyFeature2: {},
      keyFeature3: {},
      keyFeature4: {},
      plan1: {},
      plan2: {}
    },
    thanks:
      'Metrica Sportsに登録していただきありがとうございます！トライアルを開始するには、%{products} をダウンロードしてください。'
  },
  error: {
    restart: 'あなたは現在開発中のものに入ろうとしてるようです...',
    tryAgainMsg: 'このエラーが続く場合は、Metrica Sportsのサポートチームに連絡してください。'
  },
  verifyEmail: {
    generateLink: 'Playにログインして新しいリンクを生成する',
    readyToLogin: 'Playにログインする準備ができました。',
    successfully: 'メールが正常に確認されました',
    unsuccessfully: 'メールの確認中にエラーが発生しました。トークンが無効です'
  }
}
